export default __webpack_public_path__ + "static/media/Bin.17337b6f.svg";